import React from 'react';
import { FieldError } from 'react-hook-form';
import { Icon } from '@ansvar-sakerhet/ui/src/icons/Icon';

import { S } from './Input.styles';

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: FieldError | undefined;
}

export const Input = React.forwardRef<HTMLInputElement, Props>((props, ref) => {
  const { label, type, error, ...rest } = props;
  const [showPassword, setShowPassword] = React.useState(false);
  const isPassword = type === 'password';
  const inputType = isPassword && showPassword ? 'text' : type;

  return (
    <div>
      <S.Wrapper>
        {label && <S.Label>{label}</S.Label>}
        <S.InputRow>
          <S.Input
            {...rest}
            ref={ref}
            type={inputType}
            $hasEndAdornment={isPassword}
          />
          {isPassword && (
            <S.TogglePassword
              type="button"
              onClick={() => setShowPassword((visible) => !visible)}
              aria-label={showPassword ? 'Dölj lösenord' : 'Visa lösenord'}
            >
              <Icon
                src={showPassword ? 'EyeOff' : 'Eye'}
                width={20}
                height={20}
              />
            </S.TogglePassword>
          )}
        </S.InputRow>
      </S.Wrapper>
      {error && (
        <S.Error>
          <S.B3 $color="error">{error.message}</S.B3>
        </S.Error>
      )}
    </div>
  );
});
